import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/emergencycenter';

const sortTableFields = ["name", "active"];
const sortDatabaseFields = ["name","active"];

const serviceName = "Emergency-Center-Service: ";

export default class EmergencyCenterService {
    
    static async readAllFromAPI(successF, errorF) {
        await WrapperService.get(API_URL, null, serviceName, successF, errorF);
    }

    static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
        await WrapperService.get(API_URL + '/page', {params : params}, serviceName, successF, errorF);
    }

    static async readFromAPI(emergencyId, successF, errorF) {
        await WrapperService.get(API_URL + '/' + emergencyId, null, serviceName, successF, errorF);
    }
}